import * as yup from "yup";

const loginSchema = yup
  .object({
    email: yup.string().required("Email é obrigatório"),
    password: yup.string().required("Password é obrigatório"),
  })
  .required();

export default loginSchema;
